import { useAuth } from '@/auth/hyper-auth'

const overrideConfig = {
    baseURL: process.env.VUE_APP_PROFILE_API_URL,
    namespace: process.env.VUE_APP_NAMESPACE,
    serviceGroup: process.env.VUE_APP_SERVICE
}

const service = {
    resetPassword ({ email }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.put('/users/password/reset', { email })
    },
    getUserSigninHistory (userIdx) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.get('/users/' + userIdx + '/login-history')
    },
    getProfileUserInfo (userIdx) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.get('/users/' + userIdx)
    },
    changePassword ({ userIdx, currentPassword, newPassword, newPasswordConfirm }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.put('/users/' + userIdx + '/password', { userIdx, oldPassword: currentPassword, newPassword, newPasswordConfirm })
    },
    changeLater (userIdx) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.put('/users/' + userIdx + '/password/extension')
    },
    setOtp ({ userIdx, secretKey }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.post('/users/' + userIdx + '/otp', { secretKey })
    },
    unsetOtp (userIdx) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.delete('/users/' + userIdx + '/otp')
    },
    signAgreement ({ userIdx, signedTc }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.put('/users/' + userIdx + '/signed-tc', { userIdx, signedTc })
    }
}
export {
    service,
    overrideConfig,
    useAuth
}
